import { render } from "./SupplierDetailFeesTab.vue?vue&type=template&id=7a78eac4&scoped=true"
import script from "./SupplierDetailFeesTab.vue?vue&type=script&lang=js"
export * from "./SupplierDetailFeesTab.vue?vue&type=script&lang=js"

import "./SupplierDetailFeesTab.vue?vue&type=style&index=0&id=7a78eac4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a78eac4"]])

export default __exports__